<!-- /****************************************************************************************************************
* ©2018 EdgeVerve Systems Limited, Bangalore, India. All Rights Reserved.
*
* The EdgeVerve proprietary software program ("Program"), is protected by copyrights laws, international treaties and
* other pending or existing intellectual property rights in India, the United States and other countries. The Program
* may contain / reference third party or open source components, the rights to which continue to remain with the
* applicable third party licensors or the open source community as the case may be and nothing here transfers the
* rights to the third party and open source components, except as expressly permitted. Any unauthorized reproduction,
* storage, transmission in any form or by any means (including without limitation to electronic, mechanical, printing,
* photocopying, recording or otherwise), or any distribution of this Program, or any portion of it, may result in
* severe civil and criminal penalties, and will be prosecuted to the maximum extent possible under the law.
*****************************************************************************************************************/
-->
@if (showSpinner) {
  <div class="spinner-section">
    <mat-progress-spinner class="spinner" color="primary" mode="indeterminate"> </mat-progress-spinner>
  </div>
}
<div style="display: flex; flex-direction: row; gap: 10px" class="dynamic-component-loader">
  <div style="flex: 1 1 15%; max-width: 15%; box-sizing: border-box" [ngClass]="templateDraggable?'':'hide'" class="template-section">
    <ng-template #templateLibrary> </ng-template>
    <div style="display: flex; flex-direction: row; justify-content: center; align-items: center" class="action-button">
      <button mat-button mat-raised-button class="mat-primary" type="button" (click)="freezeTemplate()">Freeze Layout</button>
    </div>
  </div>
  <div style="flex: 1 1 15%; max-width: 15%; box-sizing: border-box" [ngClass]="templateDraggable?'hide':''" class="component-section">
    <ng-template #componentLibrary> </ng-template>
    @if (flexibleTemplate) {
      <div style="display: flex; flex-direction: row; justify-content: center; align-items: center" class="action-button">
        <button mat-button mat-raised-button class="mat-primary" type="button" (click)="changeTemplateDesign()">Change
        Layout</button>
      </div>
    }
    <div style="display: flex; flex-direction: row; justify-content: center; align-items: center" class="action-button">
      <button mat-button mat-raised-button class="mat-primary" type="button" (click)="saveScreen()">Save Screen</button>
    </div>
  </div>
  <div style="flex: 1 1 85%; max-width: 85%; box-sizing: border-box" class="section">
    <div style="flex: 1 1 100%; max-width: 100%; box-sizing: border-box" class="top-section" (drop)="dropTemplate($event)" (dragover)="allowDrop($event)">
      <ng-template #templateHolder> </ng-template>
    </div>
  </div>
</div>


